import React from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import "../components/all.css";
 

const LogoScroller = class extends React.Component {
  render() {
    return (
      <CarouselProvider
      naturalSlideHeight={25}
      naturalSlideWidth={100}
        totalSlides={7}
        visibleSlides={3}
        infinite={true}
        isPlaying={true}
        interval={3500}
        className="logo-scroller"
      >
        <Slider className="logo-slider">
          <Slide className="logo-slide" innerClassName="logo-slide-inner" index={0}>
                <img src="../img/RGA.svg" alt="logo" />
            </Slide>
            <Slide className="logo-slide" innerClassName="logo-slide-inner" index={0}>
                <img src="../img/babylon.svg" alt="logo" />
            </Slide>
            <Slide className="logo-slide" innerClassName="logo-slide-inner" index={0}>
                <img src="../img/socialpoint.svg" alt="logo" />
            </Slide>
            <Slide className="logo-slide" innerClassName="logo-slide-inner" index={0}>
                <img src="../img/huge.svg" alt="logo" />
            </Slide>
            <Slide className="logo-slide" innerClassName="logo-slide-inner" index={0}>
                <img src="../img/xyz.svg" alt="logo" />
            </Slide>
            <Slide className="logo-slide" innerClassName="logo-slide-inner" index={0}>
                <img src="../img/vccp.svg" alt="logo" />
            </Slide>
            <Slide className="logo-slide" innerClassName="logo-slide-inner" index={0}>
                <img src="../img/oliver.svg" alt="logo" />
            </Slide>

        </Slider>
      </CarouselProvider>
    );
  }
}

export default LogoScroller;